import React, { useEffect, useState } from "react";

import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {
  userSignInAction,
  userSignUpAction,
  userSignUpActionBusiness,
} from "../redux/actions/userAction";
import { useNavigate } from "react-router-dom";
import heroImage from "../images/hero_1.jpg";
import { toast } from "react-toastify";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
function BusinessRegister() {
  const [content, setContent] = useState("");
  const handleQuillChange = (value) => {
    setContent(value);
    const strippedValue = value.replace(/^<p>(.*?)<\/p>$/, "$1");
    formik.setFieldValue("companyDescription", strippedValue);
  };

  const validationSchema = yup.object({
    username: yup
      .string("Enter your name")
      .min(3)
      .max(30)
      .required("firstName is required."),
    email: yup
      .string("Enter your email")
      .email("Enter a valid email")
      .required("Email is required"),
    position: yup
      .string("Enter your position")
      .required("Position is required"),
    password: yup
      .string("Enter your password")
      .min(8, "Password should be of minimum 8 characters length")
      .required("Password is required"),
    confirmPassword: yup
      .string()
      .required("Confirm password is required")
      .oneOf([yup.ref("password"), null], "Passwords must match"),
    whoami: yup
      .string("Enter a small description")
      .required("Who am i is required"),
    company: yup.string().min(3).required("company name is required."),
    tagline: yup.string().min(3).required("tagline is required"),
    companyLocation: yup
      .string()
      .min(3)
      .required("company Location is required."),
    companyDescription: yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      username: "",
      email: "",
      position: "",
      whoami: "",
      password: "",
      confirmPassword: "",
      company: "",
      tagline: "",
      companyLocation: "",
      companyDescription: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values, actions) => {
      const businessData = {
        username: values.username,
        email: values.email,
        password: values.password,
        whoami: values.whoami,
        profilePic: null,
      };
      const companyData = {
        company: values.company,
        tagline: values.tagline,
        companyLocation: values.companyLocation,
        companyDescription: values.companyDescription,
      };
      console.log(companyData);
      // dispatch(userSignUpAction(businessData,companyData ,navigate));
      // actions.resetForm();
    },
  });

  const submit = (e) => {
    e.preventDefault();
    const businessData = {
      username: formik.values.username,
      email: formik.values.email,
      password: formik.values.password,
      whoami: formik.values.whoami,
      type: "businessman",
    };
    const companyData = {
      name: formik.values.company,
      tagline: formik.values.tagline,
      location: formik.values.companyLocation,
      description: formik.values.companyDescription,
      document: document,
      companyLogo: Logo,
    };
    dispatch(userSignUpActionBusiness(businessData, companyData, navigate));
    // formik.handleSubmit();
  };
  const [document, setDocument] = useState({ name: "", url: "" });
  const [Logo, setLogo] = useState({ name: "", url: "" });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleDocumentChange = (file) => {
    if (file === undefined) {
      toast.error("select a valid pdf file!");
      return;
    }
    // Check if the file is an pdf or word
    if (
      file.type !== "application/pdf" &&
      file.type !==
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      toast.error("select a valid pdf file!");
      return;
    }
    const reader = (readFile) =>
      new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = () => resolve(fileReader.result);
        fileReader.readAsDataURL(readFile);
      });
    reader(file).then((result) =>
      setDocument({ name: file?.name, url: result })
    );
  };
  const handleLogoChange = (file) => {
    if (file === undefined) {
      toast.error("select a valid Image file!");
      return;
    }
    // Check if the file is an pdf or word
    if (
      file.type === "application/pdf" &&
      file.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      toast.error("select a valid Image!");
      return;
    }
    const reader = (readFile) =>
      new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = () => resolve(fileReader.result);
        fileReader.readAsDataURL(readFile);
      });
    reader(file).then((result) => setLogo({ name: file?.name, url: result }));
  };

  const { userInfo, loading } = useSelector((state) => state.signUp);

  console.log(loading);

  return (
    <>
      <section
        class="section-hero  inner-page"
        id="home-section"
        style={{
          backgroundColor: "rgb(64,64,64)",
        }}
      >
        <div class="container">
          <div class="row">
            <div class="col-md-7">
              <h1
                class="text-white"
                style={{
                  fontSize: "3rem",
                  fontWeight: "400",
                }}
              >
                Register as a Business Man
              </h1>
              <div class="custom-breadcrumbs">
                <a
                  href="/"
                  style={{
                    textDecoration: "none",
                  }}
                >
                  Home
                </a>{" "}
                <span class="mx-2 slash">/</span>
                <span class="text-white">
                  <strong>Register</strong>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <section
          class=""
          style={{
            paddingBottom: "100px",
            paddingTop: "50px",
            paddingLeft: "100px",
            paddingRight: "100px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "800px",
            placeItems: "center",
          }}
        >
          <div
            class=""
            style={{
              padding: "5%",
              boxShadow: "5px 5px 8px #71717a",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "auto",
            }}
          >
            <form className="contain-register" onSubmit={submit}>
              <div className="row form-group">
                <div className="col-md-12 mb-4 mb-md-0">
                  <h2 className="mb-4">Sign Up To JobBoard</h2>
                  <label className="text-black" htmlFor="fname">
                    <b>Username</b>
                  </label>
                  <input
                    type="text"
                    id="username"
                    name="username"
                    className="form-control mb-4"
                    placeholder="Enter your username"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.username}
                    style={{
                      borderColor:
                        formik.errors.username && formik.touched.username
                          ? "red"
                          : "",
                      backgroundColor:
                        formik.errors.username && formik.touched.username
                          ? "#fce7f3"
                          : "",
                    }}
                  />
                  {formik.errors.username && formik.touched.username && (
                    <p style={{ color: "red" }}>{formik.errors.username}</p>
                  )}
                </div>

                <div className="col-md-12 mb-3 mb-md-0">
                  <label className="text-black" htmlFor="fname">
                    <b>Business Email</b>
                  </label>
                  <input
                    type="text"
                    id="email"
                    name="email"
                    className="form-control mb-4"
                    placeholder="Email your email"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                    style={{
                      borderColor:
                        formik.errors.email && formik.touched.email
                          ? "red"
                          : "",
                      backgroundColor:
                        formik.errors.email && formik.touched.email
                          ? "#fce7f3"
                          : "",
                    }}
                  />
                  {formik.errors.email && formik.touched.email && (
                    <p style={{ color: "red" }}>{formik.errors.email}</p>
                  )}
                </div>
                <div className="col-md-12 mb-3 mb-md-0">
                  <label className="text-black" htmlFor="whoami">
                    <b>Who Am I</b>
                  </label>
                  <input
                    type="text"
                    id="whoami"
                    name="whoami"
                    className="form-control mb-4"
                    placeholder="small description about yourself"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.whoami}
                    style={{
                      borderColor:
                        formik.errors.whoami && formik.touched.whoami
                          ? "red"
                          : "",
                      backgroundColor:
                        formik.errors.whoami && formik.touched.whoami
                          ? "#fce7f3"
                          : "",
                    }}
                  />
                  {formik.errors.whoami && formik.touched.whoami && (
                    <p style={{ color: "red" }}>{formik.errors.whoami}</p>
                  )}
                </div>

                <br />
              </div>

              <div className="row form-group">
                <div className="col-md-12 mb-3 mb-md-0">
                  <label className="text-black" htmlFor="password">
                    <b> Password</b>
                  </label>
                  <input
                    type="password"
                    id="password"
                    name="password"
                    className="form-control mb-4"
                    placeholder="Password"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.password}
                    style={{
                      borderColor:
                        formik.errors.password && formik.touched.password
                          ? "red"
                          : "",
                      backgroundColor:
                        formik.errors.password && formik.touched.password
                          ? "#fce7f3"
                          : "",
                    }}
                  />
                  {formik.errors.password && formik.touched.password && (
                    <p style={{ color: "red" }}>{formik.errors.password}</p>
                  )}
                </div>
              </div>
              <div className="row form-group mb-4">
                <div className="col-md-12 mb-3 mb-md-0">
                  <label className="text-black" htmlFor="fname">
                    <b>Re-Type Password</b>
                  </label>
                  <input
                    type="password"
                    name="confirmPassword"
                    id="fname"
                    className="form-control mb-4"
                    placeholder="Re-type Password"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.confirmPassword}
                    style={{
                      borderColor:
                        formik.errors.confirmPassword &&
                        formik.touched.confirmPassword
                          ? "red"
                          : "",
                      backgroundColor:
                        formik.errors.confirmPassword &&
                        formik.touched.confirmPassword
                          ? "#fce7f3"
                          : "",
                    }}
                  />
                  {formik.errors.confirmPassword &&
                    formik.touched.confirmPassword && (
                      <p style={{ color: "red" }}>
                        {formik.errors.confirmPassword}
                      </p>
                    )}
                </div>
              </div>

              <div className="container border-1">
                <div className="row mb-1">
                  <div className="col-lg-12">
                    <h3 className="text-black my-5 border-bottom pb-2">
                      <b>Company Details</b>
                    </h3>
                    <div class="form-group">
                      <label for="company-website-tw d-block">
                        <b>Upload Featured Logo</b>
                      </label>{" "}
                      <br />
                      <label
                        class="btn btn-primary btn-md btn-file"
                        style={{
                          backgroundColor: "#1d4ed8",
                          borderColor: "#1d4ed8",
                        }}
                      >
                        Browse File
                        <input
                          type="file"
                          onChange={(e) => handleLogoChange(e.target.files[0])}
                        />
                      </label>
                      <br />
                      {Logo.url && (
                        <img
                          src={Logo.url}
                          alt="image"
                          style={{ width: "100px" }}
                        />
                      )}
                    </div>
                    <div className="form-group">
                      <label htmlFor="company-name">
                        <b>Company Name</b>
                      </label>
                      <input
                        type="text"
                        className="form-control mb-4"
                        id="company-name"
                        name="company"
                        placeholder="e.g. Meta"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.company}
                        style={{
                          borderColor:
                            formik.errors.company && formik.touched.company
                              ? "red"
                              : "",
                          backgroundColor:
                            formik.errors.company && formik.touched.company
                              ? "#fce7f3"
                              : "",
                        }}
                      />
                      {formik.errors.company && formik.touched.company && (
                        <p style={{ color: "red" }}>{formik.errors.company}</p>
                      )}
                    </div>

                    <div className="form-group">
                      <label htmlFor="company-tagline">
                        <b>Tagline (Optional)</b>
                      </label>
                      <input
                        type="text"
                        className="form-control mb-4"
                        id="company-tagline"
                        name="tagline"
                        placeholder="e.g. htmlFor a better future with innovations"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.tagline}
                        style={{
                          borderColor:
                            formik.errors.tagline && formik.touched.tagline
                              ? "red"
                              : "",
                          backgroundColor:
                            formik.errors.tagline && formik.touched.tagline
                              ? "#fce7f3"
                              : "",
                        }}
                      />
                      {formik.errors.tagline && formik.touched.tagline && (
                        <p style={{ color: "red" }}>{formik.errors.tagline}</p>
                      )}
                    </div>
                    <div className="form-group">
                      <label htmlFor="company-tagline">
                        <b>Location</b>
                      </label>
                      <input
                        type="text"
                        className="form-control mb-4"
                        id="company-tagline"
                        name="companyLocation"
                        placeholder="e.g. New York"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.companyLocation}
                        style={{
                          borderColor:
                            formik.errors.companyLocation &&
                            formik.touched.companyLocation
                              ? "red"
                              : "",
                          backgroundColor:
                            formik.errors.companyLocation &&
                            formik.touched.companyLocation
                              ? "#fce7f3"
                              : "",
                        }}
                      />
                      {formik.errors.companyLocation &&
                        formik.touched.companyLocation && (
                          <p style={{ color: "red" }}>
                            {formik.errors.companyLocation}
                          </p>
                        )}
                    </div>

                    <div className="form-group">
                      <label htmlFor="job-description">
                        <b>Company Description</b>
                      </label>
                      <div className="editor" id="editor-2">
                        <ReactQuill
                          theme="snow"
                          name="companyDescription"
                          value={content}
                          onChange={handleQuillChange}
                          style={{ height: "300px" }}
                        />{" "}
                        {formik.errors.companyDescription &&
                          formik.touched.companyDescription && (
                            <p style={{ color: "red" }}>
                              {formik.errors.companyDescription}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="">
                      <label htmlFor="documents">
                        <b>Upload document</b>
                        <br />
                      </label>
                      <input
                        type="file"
                        className="input-group mb-2"
                        id="documents"
                        name="documents"
                        onChange={(e) =>
                          handleDocumentChange(e.target.files[0])
                        }
                      />
                    </div>
                    <br />
                    <input
                      type="submit"
                      value="Sign Up"
                      className="btn px-4 btn-primary text-white"
                      style={{
                        backgroundColor: "#1d4ed8",
                        borderColor: "#1d4ed8",
                        width: "100%",
                        height: "50px",
                      }}
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </section>
      </div>
    </>
  );
}

export default BusinessRegister;
